import { styled } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

export const LoginButton = styled(Button)(({ theme }) => ({
	display: 'flex',
	padding: '4px 12px',
	borderRadius: theme.spacing(1.5),
	background: 'linear-gradient(90deg, #1D3546 0%, #24475E 100%)',
	boxShadow: '0px 2px 12px 0px rgba(29, 53, 70, 0.03)',
	color: '#fff',
	textTransform: 'none',
	zIndex: 3
}));
